import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IUserPolls } from 'src/app/models/user-polls';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';

@Component({
  selector: 'app-poll-result-dialog',
  templateUrl: './poll-result-dialog.component.html',
  styleUrls: ['./poll-result-dialog.component.scss'],
})
export class PollResultDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IUserPolls,
    private _screenSize: AumyeResponsiveScreenService
  ) {
    this.options = JSON.parse(data.pollOptions);
    this.pollResponse = JSON.parse(data.pollResponse);
    this._screenSize.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }

  pollResults: PollResult[] = [];
  screenSize: ScreenType;
  ScreenType = ScreenType;
  choosedResponse: string;
  options: string[] = [];
  pollResponse: Response[] = [];
  totalCount: number = 0;

  ngOnInit() {
    for (const option of this.options) {
      const matchingResponses = this.pollResponse?.filter(
        (response) => response.Response === option
      );

      const count = matchingResponses ? matchingResponses.length : 0;
      this.totalCount += count;
      const result: PollResult = {
        Option: option,
        Responses: matchingResponses,
        Count: count,
      };
      this.pollResults.push(result);
    }
  }
  getResult(poll: PollResult) {
    if (poll.Count != 0) {
      let result = ((poll.Count * 100) / this.totalCount).toFixed(2);
      return result + '%';
    } else return '0%';
  }
}

export interface Response {
  Response: string;
  UserId: string;
  SubmitTime: Date;
}
export interface PollResult {
  Option: string;
  Responses: Response[];
  Count: number;
}
